import { Paper, RaisedButton } from 'material-ui';
import * as React from 'react';
import { Views } from '../abstract';
import './SignInViewStyles.css';

interface ISignInViewProps {
    signIn: () => void
}

class SignInView<P, S> extends Views.View<P & ISignInViewProps, S & Interfaces.IViewState> {

    constructor(props: any) {
        super(props)
        this.state = { error: '', model: this.props.model } as any
    }

    public validateForm() {
        const { model } = this.props;
        if (model['login'] && model['password']) {
            this.props.signIn()
        } else {
            this.setState({ error: 'Заполните все поля!' })
        }

    }

    public render() {
        return (
            <div className="signin-container">
                <Paper
                    className="paper"
                >
                    <h1 className="title" >Авторизация</h1>
                    <Views.TextField
                        name="login"
                        floatingLabelText="Почта"
                        hintText="Введите почту"
                        fullWidth={true}
                        // tslint:disable-next-line:jsx-no-lambda
                        onChange={(e) => this.onTextChange(e)}
                    />
                    <Views.TextField
                        name="password"
                        type="password"
                        floatingLabelText="Пароль"
                        hintText="Введите пароль"
                        fullWidth={true}
                        // tslint:disable-next-line:jsx-no-lambda
                        onChange={(e) => this.onTextChange(e)}
                        // tslint:disable-next-line:jsx-no-lambda
                        onKeyDown={(e) => e['key'] === 'Enter' ? this.validateForm() : null}
                    />
                    {this.errorLabel()}
                    <RaisedButton
                        className="signin-button"
                        label='Войти'
                        fullWidth={true}
                        backgroundColor="black"
                        labelColor="#fff"
                        style={{ height: 40 }}
                        // tslint:disable-next-line:jsx-no-lambda
                        onClick={() => this.validateForm()}
                    />
                    {this.loadingView()}
                </Paper>
            </div>
        );
    }
}

export default SignInView;



// WEBPACK FOOTER //
// ./src/app/authorization/SignInView.tsx